import { gql } from "lib/apolloClient";
import { studentsAlertFragment } from "modules/CommonFragments";

export const getOrganizationBasicCoursesQuery = gql`
  query getOrganizationCoursesQuery(
    $organizationId: ID!
    $filters: CourseFilterInput
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        ...organizationCourseItem
      }
    }
  }

  fragment organizationCourseItem on Organization {
    id
    courses(orderBy: TITLE, orderByDirection: ASC, filters: $filters) {
      edges {
        node {
          ...courseItem
        }
      }
    }
  }

  fragment courseItem on Course {
    id
    title
    curriculumProgram {
      id
      type
    }
  }
`;

export const getStudentFamilyStatusInsightsQuery = gql`
  query getStudentFeed(
    $organizationId: ID!
    $filters: OrgConnectionFilterInput
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        students(filters: $filters) {
          totalCount
          totalCountsByFamilyStatus {
            totalCount
            totalUnconnected
            totalConnected
            totalInvited
            totalApproveRequested
            totalPending
          }
        }
      }
    }
  }
`;

export const getStudentsAndFamiliesQuery = gql`
  query getStudentAndFamiliesFeed(
    $organizationId: ID!
    $after: String
    $filters: OrgConnectionFilterInput
    $orderBy: ORDER_BY_ENUM
    $orderByDirection: ORDER_BY_DIRECTION
    $familiesFilter: FamiliesFiltersInput
    $first: Int
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        ...organizationStudentFeedEdgeItem
        __typename
      }
      __typename
    }
  }

  fragment organizationStudentFeedEdgeItem on Organization {
    id
    students(
      first: $first
      after: $after
      filters: $filters
      orderBy: $orderBy
      orderByDirection: $orderByDirection
    ) {
      totalCount
      edges {
        node {
          ...studentItem
        }
      }
    }
  }

  fragment studentItem on Student {
    id
    firstName
    middleName
    lastName
    pronouns
    preferredName
    suffix
    prefix
    type
    familyInviteCode
    signInCode
    sourceId
    alertTypes {
      ...alertTypeFields
    }
    families(filters: $familiesFilter) {
      id
      status
      familyMember {
        id
        lastName
        middleName
        firstName
        pronouns
        preferredName
        suffix
        prefix
        type
        email
        isCreatedByOrg
        __typename
      }
      createdAt
      lastUpdatedAt
      __typename
    }
    email
  }
  ${studentsAlertFragment}
`;

export const getStudentFamilyStatusInsightsQueryV2 = gql`
  query getStudentFeed(
    $organizationId: ID!
    $filters: OrgConnectionFilterInput
    $familyStatus: TotalCountsByFamilyStatusFilters
    $orderBy: ORDER_BY_ENUM
    $orderByDirection: ORDER_BY_DIRECTION
    $after: String
    $familyMembersCountFilter: FamilyMembersFilterInput
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        familyMembers(filters: $familyMembersCountFilter) {
          totalCount
        }
        students(
          first: 20
          after: $after
          filters: $filters
          orderBy: $orderBy
          orderByDirection: $orderByDirection
        ) {
          totalCount
          totalCountsByFamilyStatus(filters: $familyStatus) {
            totalCount
            totalUnconnected
            totalConnected
            totalInvited
            totalApproveRequested
            totalPending
            totalNotActiveSince
          }
        }
      }
    }
  }
`;

export const getStudentsWithFamilyQuery = gql`
  query getStudentsWithFamily(
    $organizationId: ID!
    $after: String
    $filters: OrgConnectionFilterInput
    $orderBy: ORDER_BY_ENUM
    $orderByDirection: ORDER_BY_DIRECTION
    $familiesFilter: FamiliesFiltersInput
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        students(
          first: 20
          after: $after
          filters: $filters
          orderBy: $orderBy
          orderByDirection: $orderByDirection
        ) {
          totalCount
          blockedCount
          edges {
            node {
              id
              firstName
              middleName
              lastName
              profileImage
              email
              families(filters: $familiesFilter) {
                id
                status
                familyMember {
                  id
                  lastName
                  middleName
                  firstName
                  email
                }
              }
              academicYears {
                id
                startDate
                endDate
              }
              alertTypes {
                id
                name
                icon
              }
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }
`;
